// src/components/ACS-Dashboard/ACS-Blocks/Pagination/GlobalPagination.js
import React from "react";

const GlobalPagination = ({
  label = "Items per page",
  currentPage,
  totalPages,
  onPageChange,
  itemsPerPage,
  onItemsPerPageChange,
  options = [50, 100, 150],
}) => {
  const handleNextPage = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  return (
    <div className="flex justify-between items-center border-t border-gray-200 dark:border-acs-dark-border bg-white dark:bg-acs-dark-surface p-fluid-1 transition-none">
      {/* Left side: per-page selector */}
      <div className="flex items-center text-gray-800 dark:text-acs-dark-text font-roboto text-fluid-base">
        <span className="mr-2">{label}</span>
        <select
          value={itemsPerPage}
          onChange={(e) => {
            onItemsPerPageChange(Number(e.target.value));
            onPageChange(1); // reset to first page
          }}
          className="border-b-2 border-gray-400 dark:border-acs-dark-border bg-transparent 
                    text-gray-800 dark:text-acs-dark-text 
                    focus:outline-none focus:border-[#223688] dark:focus:border-acs-dark-hover
                    transition-none"
        >
          {options.map((num) => (
            <option
              key={num}
              value={num}
              className="bg-white dark:bg-acs-dark-surface text-gray-800 dark:text-acs-dark-text"
            >
              {num}
            </option>
          ))}
        </select>
      </div>

      {/* Right side: pagination buttons */}
      <div className="flex items-center text-gray-700 dark:text-acs-dark-text font-roboto text-fluid-base">
        <button
          onClick={handlePrevPage}
          disabled={currentPage === 1}
          className="mx-2 text-gray-500 dark:text-acs-dark-subtext hover:text-[#223688] dark:hover:text-acs-dark-hover disabled:opacity-50 transition-none"
        >
          ❮
        </button>
        <span className="mx-1">
          {currentPage} of {totalPages}
        </span>
        <button
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          className="mx-2 text-gray-500 dark:text-acs-dark-subtext hover:text-[#223688] dark:hover:text-acs-dark-hover disabled:opacity-50 transition-none"
        >
          ❯
        </button>
      </div>
    </div>
  );
};

export default GlobalPagination;
